<template>
  <div class="footer_wrapper">
    地址：四川省南充市顺庆区大学城   官方邮箱：ncdygyzyxy@163.com<br/>
    Copyright © 2002-2021南充电影工业职业学院 All Rights Reserved
  </div>
</template>

<script>
// import { } from "@ant-design/icons-vue";

import { defineComponent } from "vue";

// import { useRoute } from "vue-router";
export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    //*********** definning variables end **********//
    //*********** initData start **********//
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    //*********** DOM FUN end **********//
  },
});
</script>
<style lang="scss">
.footer_wrapper{background: #383838; text-align: center; color: #f1f1f1; padding: 40px 0; line-height: 2; font-size: 12px;}
</style>
